import defaultSettings from '../settings.json';
const initialState = {
  settings: defaultSettings,
  userInfo: {
    user_type: 'guest',
    permissions: {}
  }
};
export default function store(state = initialState, action) {
  switch (action.type) {
    case 'update-settings':
      {
        const {
          settings
        } = action.payload;
        return {
          ...state,
          settings
        };
      }
    case 'update-userInfo':
      {
        const {
          userInfo = initialState.userInfo,
          userLoading
        } = action.payload;
        return {
          ...state,
          userLoading,
          userInfo
        };
      }
    case 'update-menu':
      {
        const {
          menuInfo,
          menuLoading
        } = action.payload;
        return {
          ...state,
          menuLoading,
          menuInfo
        };
      }
    case 'update-dict':
      {
        const {
          dicts
        } = action.payload;
        return {
          ...state,
          dicts
        };
      }
    default:
      return state;
  }
}